export { default as DocumentMinusSolidIcon } from './DocumentMinusSolidIcon';
